const box = "_35sb1bylbgv";
const content = "_35scfcb8gc";
const toggle = "_35st1owaoqj";
const icon = "_35si58env8";

export { box, content, icon, toggle };
import "./_text-box.style.linaria.module.css";
//# sourceMappingURL=_text-box.style.js.map
